var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion"},_vm._l((_vm.accordionSections),function(section,index){return _c('AccordionSection',{key:section.title,attrs:{"index":index,"section":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }